import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
import { saveSelectedDate, saveSelectedDay } from '../../../../../features/schedule/schedule-slice';
import { formatShortedAvailableDays, formatTimeLabel } from '../../../../../lib/dayjs';
import { FeaturedScheduleDay } from '../../../../../services/availableTimes.service';
import FeaturedAppointmentItemModel from './model';

type FeaturedAppointmentItemViewModelProps = {
  featuredScheduleDays: FeaturedScheduleDay[];
};

export default function FeaturedAppointmentItemViewModel({ featuredScheduleDays }: FeaturedAppointmentItemViewModelProps) {
  const dispatch = useDispatch();
  const model = FeaturedAppointmentItemModel;
  const {
    schedule: { dateStart }
  } = useSelector((state: RootState) => state);

  const onSelectTime = (time: string) => {
    dispatch(saveSelectedDay(time.split('T')[0]));
    dispatch(saveSelectedDate(time));
  };

  const days = (featuredScheduleDays ?? []).map(day => ({
    date: day.date,
    label: formatShortedAvailableDays(day.date),
    times: day.times.map(time => ({
      time,
      label: formatTimeLabel(time),
      selected: model.isSelected(time, dateStart)
    }))
  }));

  return { days, onSelectTime };
}
